module.exports = __webpack_public_path__ + "static/media/arrows-h.31beeeb2.svg";